export default function () {
  return {
    current: {
      id: '',
      vendorId: '',
      name: '',
      location: '',
      model: '',
      serialNumber: '',
      manufacturer: '',
      ip: '',
      mac: '',
      logicalId: '',
      firmwareVersion: '',
      operatingPriority: 0,
      active: false,
      status: '',
      deletedAt: null,
      reenableTime: null,
      building: '',
      system: null,
      healthChecks: [],
      cameras: [],
      history: {},
      notes: false
    },
    update: {
      id: '',
      building: null,
      active: false,
      reenableTime: null
    },
    list: [],
    canInactivateForever: true
  }
}
